import React from 'react';
import { Row, Col, Form, Input } from 'antd';

import './AddressInput.css';

import DictionarySelect from 'components/DictionarySelect';
import ProvinceSelect from 'components/ProvinceSelect';

export default class AddressInput extends React.Component {
	render() {
		const { getFieldDecorator, disabled } = this.props;
		const requiredRules = (this.props.required) ? [{ required: true }] : [];
		const prefix = this.props.type || '';
		return (
			<div className="AddressInput inResco">
				<DictionarySelect
					placeholder={(disabled) ? '' : 'Country'}
					prefix={prefix}
					form={this.props.form}
					showAbbreviations={this.props.showAbbreviations}
					code="CNT"
					field="Country"
					disabled={disabled}
					initialValue={this.props.address.Country}
					getFieldDecorator={getFieldDecorator}
					required={this.props.required}
					exclude={['M0']}
					onChange={(e) => {
						let update = {};
						update[prefix+'Province'] = '';
						this.props.form.setFieldsValue(update);
					}} />
				<div className="box">
					<Form.Item style={{marginBottom: 0}}>
						{getFieldDecorator(prefix+'Street', {
							initialValue: this.props.address.Street,
							rules: requiredRules.concat([{
								transform: (value) => {
									if (typeof value === 'string') return value.split('\n');
									else return '';
								},
								validator: (rule, value, callback) => {
									if (value === '') callback();
									else if (value.length > 3) callback('Street address has too many lines');
									else if (value.find(line => line.length > 35)) callback('Street address lines have a maximum length of 35 characters');
									else callback();
								}
							}])
						})(
							<Input.TextArea rows="3" className="street" placeholder={(disabled) ? '' : '123 Main St.'} disabled={disabled} />
						)}
					</Form.Item>
					<Row>
						<Col xs={8}>
							<Form.Item>
								{getFieldDecorator(prefix+'City', {
									initialValue: this.props.address.City,
									rules: requiredRules.concat([{max:20,}])
								})(
									<Input className="city" size="large" placeholder={(disabled) ? '' : 'City'} disabled={disabled} />
								)}
							</Form.Item>
						</Col>
						<Col xs={8}>
							<ProvinceSelect
								className="state"
								prefix={prefix}
								form={this.props.form}
								code="PRV"
								showAbbreviations={this.props.showAbbreviations}
								countryCode={this.props.form.getFieldValue(prefix+'Country')}
								field="Province"
								disabled={disabled}
								initialValue={this.props.address.Province}
								getFieldDecorator={getFieldDecorator}
								required={this.props.required} />
						</Col>
						<Col xs={8}>
							<Form.Item>
								{getFieldDecorator(prefix+'PostalCode', {
									initialValue: this.props.address.PostalCode,
									rules: [{max: 10}]
								})(
									<Input className="zip" size="large" placeholder={(disabled) ? '' : 'Postal Code'} disabled={disabled} />
								)}
							</Form.Item>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/AddressInput/index.jsx